import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialCandidateSearchSlice } from './candidate-search.slice';
import { initialRecipientSearchSlice } from './recipient-search.slice';
import { environment } from 'src/environments/environment';
import { CandidateSearch } from 'src/app/recruiting/locums-margin-calculator/models/candidate-search.model';
import { RecipientSearch } from '../../models/recipient-search.model';

export const CandidateSearchStore = signalStore(
    { providedIn: 'root' },
    withState(initialCandidateSearchSlice),
    withState(initialRecipientSearchSlice),
    withMethods((store) => {
        return {
            setCandidates(candidates: CandidateSearch[]) {
                if (!Array.isArray(candidates)) {
                    return;
                }
                patchState(store, { candidates });
            },

            setRecipients(recipients: RecipientSearch[]) {
                if (!Array.isArray(recipients)) {
                    return;
                }
                patchState(store, { recipients });
            },

            setSelectedRecipient(recipient: RecipientSearch | null) {
                if (!recipient) {
                    return;
                }
                patchState(store, { selectedRecipient: recipient });
            },

            setSelectedCandidate(candidate: CandidateSearch) {
                if (!candidate) {
                    return;
                }
                patchState(store, {
                    selectedCandidate: candidate,
                    isCandidateSelected: true
                });
            },

            setMarginId(marginId: number) {
                patchState(store, { marginId });
            },

            clearSelectedCandidate() {
                patchState(store, {
                    selectedCandidate: undefined,
                    isCandidateSelected: false
                });
            },

            clearSelectedRecipient() {
                patchState(store, { selectedRecipient: null });
            }
        };
    }),
    environment.storeWithDevTools('locums-margin-calculator-candidate-search-store')
);
